import React, {ReactNode} from "react";
import Search from "../search/search";
import ExpressServicesBlock from "../express-services-block/express-services-block";
import ChairmanBlog from "../chairman-blog/chairman-blog";
import CalendarBlock from "../calendar/calendar";
import ServiceBlockWithButton from "../service-block-with-button/service-block-with-button";
import QuestionsBlock from "../questions-block/questions-block";
import ExternalResources from "../external-resources/external-resources";
import BlockServiceList from "/site/parts/block-service-list/block-service-list";
import BlockGovServiceList from "/site/parts/block-gov-service-list/block-gov-service-list";
import ServiceLinkImg from "/site/parts/service-link-img/service-link-img";
import BlockQrLinks from "/site/parts/block-qr-links/block-qr-links";

const getBlock = (item: any, props: any) => {
    return <ServiceBlockWithButton
        {...props}
        config={{
            ...item,
            image: item.backgroundImage,
        }}
    />
};

export const getMainBlocks = (
    props: any,
    translations: any,
): ReactNode[] => {
    const arr = [];

    if (translations) {
        arr.push({
            node: <BlockGovServiceList
                {...props}
                pageName={props.config.govServiceTitle}
                image={props.config.govServiceIcon}
            />,
            id: "govService"
        });

        arr.push({
            node: <BlockServiceList
                {...props}
                pageName={props.config.serviceTitle}
                image={props.config.serviceIcon}
            />,
            id: "service"
        });

        arr.push({
            node: <ServiceLinkImg
                {...props}
                name={props.config.serviceLink1Name}
                img={props.config.serviceLink1Img}
                url={`/${props.language}${props.config.serviceLink1Url}`}
            />,
            id: "serviceLink1"
        });


        arr.push({
            node: <ServiceLinkImg
                {...props}
                name={props.config.serviceLink2Name}
                img={props.config.serviceLink2Img}
                url={`/${props.language}${props.config.serviceLink2Url}`}
            />,
            id: "serviceLink2"
        });

        arr.push({
            node: <ServiceLinkImg
                {...props}
                name={props.config.serviceLink3Name}
                img={props.config.serviceLink3Img}
                url={`/${props.language}${props.config.serviceLink3Url}`}
            />,
            id: "serviceLink3"
        });

        arr.push({
            node: <Search
                {...props}
                title={props.config.searchTitle}
                url={props.config.searchUrl}
                name={props.config.searchName}
                translations={translations}
            />,
            id: "search"
        });

        arr.push({
            node: <ExpressServicesBlock
                {...props}
                config={{
                    urlList: props.config.expUrlList,
                    url1: props.config.expUrl1,
                    url2: props.config.expUrl2,
                    url3: props.config.expUrl3,
                    url4: props.config.expUrl4,
                }}
                language={props.language}
                translations={translations}
            />,
            id: "exp"
        });

        arr.push({
            node: <ChairmanBlog
                {...props}
                config={{
                    nameBlog: props.config.chairmanNameBlog,
                    name: props.config.chairmanName,
                    image: props.config.chairmanImage,
                    link: props.config.chairmanLink,
                    questionText: props.config.chairmanQuestionText,
                }}
            />,
            id: "chairman"
        });

        arr.push({
            node: <CalendarBlock
                {...props}
                config={{
                    name: props.config.calendarName,
                }}
                translations={translations}
            />,
            id: "calendar"
        });

        if (props.config.sb) {
            arr.push({
                node: (
                    <div className="two-nested-columns">
                        <div className="xp-region">
                            {getBlock(props.config.sb[0], props)}
                        </div>
                        <div className="xp-region">
                            {getBlock(props.config.sb[1], props)}
                        </div>
                    </div>
                ),
                id: "sb"
            });
        }

        arr.push({
            node: <QuestionsBlock
                {...props}
                translations={translations}
            />,
            id: "questions"
        });

        if (props.config.qr) {
            arr.push({
                node: <BlockQrLinks
                    links={props.config.qr}
                    translations={translations}
                />,
                id: "qr"
            });
        }

        arr.push({
            node: <ExternalResources
                {...props}
                config={{
                    title: props.config.erTitle,
                    size: props.config.erSize,
                    expand: props.config.erExpand,
                    name: props.config.erName,
                }}
            />,
            id: "er"
        });
    }

    return arr;
};
